import classNames from 'classnames';
import React from 'react';
import { useTranslator } from 'tradera/lang/translate';

type OnDisplayBadgeProps = {
    className?: string;
};

export const OnDisplayBadge = ({ className }: OnDisplayBadgeProps) => {
    const { t } = useTranslator();
    return (
        <span className={classNames('badge badge-dark text-nowrap', className)}>
            {t('itemCard_onDisplay')}
        </span>
    );
};
